import { render, staticRenderFns } from "./ClientsPartner.vue?vue&type=template&id=1772ac24&"
import script from "./ClientsPartner.vue?vue&type=script&lang=js&"
export * from "./ClientsPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports